import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";
import { Section, SectionHead } from "@/components/landing/Section";
import { StoreBadges } from "@/components/landing/StoreLinks";

export default function FAQ() {
  const { t } = useLang();
  return (
    <Section id="faq" testId="faq-section" className="bg-paper/60 border-t border-line">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionHead kicker={t.faq.kicker} title={t.faq.title} />
          <p className="mt-6 font-bold text-rowan">{t.tagline}</p>
          <div className="mt-8" id="download"><StoreBadges idPrefix="faq" /></div>
        </div>
        <Accordion type="single" collapsible className="lg:col-span-8" data-testid="faq-accordion">
          {t.faq.items.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-b border-dashed border-line">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display text-lg md:text-xl font-semibold text-ink text-left hover:no-underline py-5">
                {q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-base text-ink-muted leading-relaxed pb-5">
                {a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
